/* svnty-buyrow.js — THE BUY ROW (R133 block 3, D3-11, 2026-09-20). the reference's order under the choices:
 *   [ − 1 + ]  [ ADD TO BAG ]        ← the stepper pill and the bag pill on one row
 *   In stock                          ← 11 px, muted, under the stepper
 *   (share bubble) [ ♡ ADD TO WISHLIST ]
 *   [ BUY IT NOW ]                    ← The store's black button keeps its place (R105)
 * Trade renders the quantity block and the buy buttons as two sibling blocks and re-renders the quantity block IN
 * PLACE by id on every variant change (product-info.js updateQuantityRules), so the WHOLE #Quantity-Form element is
 * moved into the row — its id and children travel with it and Trade keeps finding them. The PDP heart moves down
 * from the title row into the wish-list pill. The share bubble uses the Web Share API, else copies the link. */
(function () {
  'use strict';
  function build(info) {
    if (info.dataset.svntyBuyrow) return;
    var form = info.querySelector('.product-form__buttons');
    var submit = form && form.querySelector('.product-form__submit');
    var qty = info.querySelector('[id^="Quantity-Form-"]');
    if (!form || !submit || !qty) return;
    info.dataset.svntyBuyrow = '1';
    var row = document.createElement('div'); row.className = 'svnty-buyrow';
    form.insertBefore(row, submit);
    row.appendChild(qty); row.appendChild(submit);
    var stock = document.createElement('p'); stock.className = 'svnty-stockline'; stock.setAttribute('data-svnty-stockline', '');
    row.insertAdjacentElement('afterend', stock);
    var acts = document.createElement('div'); acts.className = 'svnty-buyacts';
    stock.insertAdjacentElement('afterend', acts);
    /* share bubble */
    var share = document.createElement('button'); share.type = 'button'; share.className = 'svnty-share'; share.setAttribute('aria-label', (window.svntyStrings && svntyStrings.share && svntyStrings.share.label) || 'Share');
    share.innerHTML = document.getElementById('svnty-share-glyph') ? document.getElementById('svnty-share-glyph').innerHTML : '';
    acts.appendChild(share);
    share.addEventListener('click', function () {
      var url = location.origin + location.pathname + location.search;
      var title = document.title;
      if (navigator.share) { navigator.share({ url: url, title: title }).catch(function () {}); return; }
      var done = function () { document.dispatchEvent(new CustomEvent('svnty:toast', { detail: { message: (window.svntyStrings && svntyStrings.share && svntyStrings.share.copied) || 'Link copied' } })); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, done); else done();
    });
    /* the heart, as the pill */
    var heart = info.querySelector('.svnty-heart--pdp');
    if (heart) {
      heart.classList.add('svnty-heart--pill'); acts.appendChild(heart);
      var lbl = heart.querySelector('[data-svnty-heart-label]'); var btn = heart.querySelector('.svnty-heart__btn');
      var W = (window.svntyStrings && svntyStrings.wishlist) || {};
      if (W.add) heart.setAttribute('data-label-save', W.add);
      if (lbl && btn && btn.getAttribute('aria-pressed') !== 'true' && W.add) lbl.textContent = W.add;
    }
    syncStock(info);
  }
  function syncStock(info) {
    var stock = info.querySelector('[data-svnty-stockline]'); var submit = info.querySelector('.product-form__submit');
    if (!stock || !submit) return;
    /* P20: an add in flight is not a sold-out size (product-form.js sets aria-disabled for the flight): the line stays, and
       the row under it no longer jumps 21 px up and back on every add */
    if (submit.classList.contains('loading')) return;
    var soldOut = submit.disabled || submit.getAttribute('aria-disabled') === 'true';
    var S = (window.svntyStrings && svntyStrings.stock) || {};
    stock.textContent = soldOut ? (S.out || 'Sold out') : (S.in || 'In stock');
    stock.classList.toggle('is-out', soldOut);
  }
  /* P15 F15-2 (2026-09-28): the line read 'In stock' under a SOLD OUT button. The variantChange event lands before or
     after Trade swaps the button depending on the fetch; the line now follows the button's own disabled attribute. */
  function watchStock(info) {
    if (info.__svntyStockWatch || typeof MutationObserver !== 'function') return;
    var submit = info.querySelector('.product-form__submit'); if (!submit) return;
    info.__svntyStockWatch = new MutationObserver(function () { syncStock(info); });
    info.__svntyStockWatch.observe(submit, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
  }
  function init() { Array.prototype.forEach.call(document.querySelectorAll('product-info'), function (i) { build(i); watchStock(i); syncStock(i); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
    try { subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(function () { Array.prototype.forEach.call(document.querySelectorAll('product-info'), function (i) { build(i); syncStock(i); }); }, 60); }); } catch (e) {}
  }
  document.addEventListener('svnty:pdp:rendered', init);
})();
